import { createImmerContext } from './createImmerContext';

export type ScaleRef = {
  min: number;
  setScale: (scale: number) => void;
  frame: { width: number; height: number };
};

/**
 * The editor's global interaction mode (the `printCardEditorModes` flag).
 * - `edit`   — content: every inline-editable text layer is editing at once, and every other
 *              layer's toolbar is reachable. Nothing moves or resizes.
 * - `layout` — geometry: move and resize only. No caret, and no toolbars.
 */
export type EditorMode = 'edit' | 'layout';

export interface SurfaceState {
  scale: number;
  hoverLayerIndex: number | undefined;
  activeLayerIndex: number | undefined;
  editingLayerIndex: number | undefined;
  scaleRef: ScaleRef | undefined;
  /**
   * `undefined` means the mode switcher is off, and interaction stays on the legacy
   * per-layer path (tap to select, tap again to drag or to enter caret editing).
   */
  mode: EditorMode | undefined;
}

const [SurfaceProvider, useSurface] = createImmerContext<SurfaceState>(() => ({
  scale: 1,
  hoverLayerIndex: undefined,
  activeLayerIndex: undefined,
  editingLayerIndex: undefined,
  scaleRef: undefined,
  mode: undefined,
}));

export { SurfaceProvider, useSurface };
